import { render, staticRenderFns } from "./ConversationThread.vue?vue&type=template&id=79ed6ed4&scoped=true&"
import script from "./ConversationThread.vue?vue&type=script&lang=js&"
export * from "./ConversationThread.vue?vue&type=script&lang=js&"
import style0 from "./ConversationThread.vue?vue&type=style&index=0&id=79ed6ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ed6ed4",
  null
  
)

export default component.exports